function padTime(value) {
	return String(value).padStart(2, '0')
}

function formatDuration(totalSeconds) {
	const minutes = Math.floor(totalSeconds / 60)
	const seconds = totalSeconds % 60
	return `${padTime(minutes)}:${padTime(seconds)}`
}

function formatNoteDuration(totalSeconds) {
	const hours = Math.floor(totalSeconds / 3600)
	const minutes = Math.floor((totalSeconds % 3600) / 60)
	const seconds = totalSeconds % 60
	if (hours > 0) return `${padTime(hours)}h ${padTime(minutes)}m`
	return `${padTime(minutes)}m ${padTime(seconds)}s`
}

function mapOwnerTypeForDrawer(ownerType) {
	if (ownerType === 'counselor') return 'you'
	return ownerType || 'you'
}

function mapActionItemForDrawer(item, index) {
	return {
		id: String(item.id || `action-${index + 1}`),
		text: String(item.text || ''),
		kodaState: 'idle',
		ownerType: mapOwnerTypeForDrawer(item.ownerType),
	}
}

export function mapSessionNoteToDrawerRecord(
	sessionNote,
	{ recordingSeconds = 0, pauseCount = 0, studentId = '', transcriptText = '' } = {},
) {
	const summary = String(sessionNote?.summary || '').trim()
	const recordingSecondsValue = Number(recordingSeconds) || 0

	return {
		id: String(sessionNote?.id || ''),
		title: String(sessionNote?.title || 'Session note'),
		createdAt: sessionNote?.createdAt || new Date().toISOString(),
		durationLabel: formatDuration(recordingSecondsValue),
		noteDurationLabel: formatNoteDuration(recordingSecondsValue),
		recordingSeconds: recordingSecondsValue,
		pauseCount: Number(pauseCount) || 0,
		transcript: String(transcriptText || ''),
		topic: String(sessionNote?.title || 'Session note'),
		keyRecommendation: '',
		generalNotes: summary
			? [
					{
						id: `general-summary`,
						text: summary,
						type: 'note',
						kodaState: 'idle',
					},
			  ]
			: [],
		actionItems: (sessionNote?.actionItems || []).map(mapActionItemForDrawer),
		speakerShares: [],
		studentId: String(studentId || sessionNote?.studentId || ''),
	}
}
